import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList } from '@fortawesome/free-solid-svg-icons';

const SurveyIcon = ({ size = 22, color = 'currentColor', className }) => (
  <FontAwesomeIcon
    icon={faClipboardList}
    className={className}
    style={{ fontSize: size, color, width: '1em', height: '1em' }}
  />
);

export default SurveyIcon;
